module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C1094"
  }, [_c('big', [_c('em', [_c('span', {
    attrs: {
      "id": "page_1"
    }
  }, [_vm._v("In ")]), _vm._v("Line for the Exterminator ")])])], 1), _vm._v(" "), _c('p', {
    staticClass: "C1098"
  }, [_vm._v("a dark ride at Kennywood Park, Pittsburgh ")]), _vm._v(" "), _c('p', {
    staticClass: "C1100"
  }, [_vm._v("Four skinheads swear and sweat ")]), _vm._v(" "), _c('p', {
    staticClass: "C1104"
  }, [_vm._v("in fat leather behind my son and me ")]), _vm._v(" "), _c('p', {
    staticClass: "C1104"
  }, [_vm._v("looping around endless rows of steel rails ")]), _vm._v(" "), _c('p', {
    staticClass: "C1104"
  }, [_vm._v("in the fake cinderblock bunker. The ride ")]), _vm._v(" "), _c('p', {
    staticClass: "C1104"
  }, [_vm._v("simulates a trip through the bowels of sewers ")]), _vm._v(" "), _c('p', {
    staticClass: "C1104"
  }, [_vm._v("beneath the city. The skinny punks who cut in line ")]), _vm._v(" "), _c('p', {
    staticClass: "C1104"
  }, [_vm._v("jokingly press the “panic button,” a blaring echo ")]), _vm._v(" "), _c('p', {
    staticClass: "C1104"
  }, [_vm._v("that mimics nightmare alarms. They won’t stop ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "C1104"
  }, [_vm._v("with their girlfriends throw scowls at the skinheads. ")]), _vm._v(" "), _c('p', {
    staticClass: "C1104"
  }, [_vm._v("Perfume and deodorant and farts and spit and melting make-up ")]), _vm._v(" "), _c('p', {
    staticClass: "C1104"
  }, [_vm._v("and exposed skin pierced or not and tattoos and thick jewelry ")]), _vm._v(" "), _c('p', {
    staticClass: "C1104"
  }, [_vm._v("and tight clothing plastered against skin of all colors. ")]), _vm._v(" "), _c('p', {
    staticClass: "C1104"
  }, [_vm._v("My son is glassy-eyed with the room’s menace—")]), _vm._v(" "), _c('p', {
    staticClass: "C1104"
  }, [_vm._v("it stings. It clings. The line crawls like a whipped dog ")]), _vm._v(" "), _c('p', {
    staticClass: "C1104"
  }, [_vm._v("toward the dark door behind which it’s promised ")]), _vm._v(" "), _c('p', {
    staticClass: "C1104"
  }, [_vm._v("we are all to be scared. A fake newscaster on a monitor ")]), _vm._v(" "), _c('p', {
    staticClass: "C1104"
  }, [_vm._v("describes a power failure. I want to ask “How many ")]), _vm._v(" "), _c('p', {
    staticClass: "C1104"
  }, [_vm._v("in this room make minimum wage? How many ")]), _vm._v(" "), _c('p', {
    staticClass: "C1104"
  }, [_vm._v("in this room will ever own a house? ")]), _vm._v(" "), _c('p', {
    staticClass: "C1104"
  }, [_vm._v("What if we all made a giant wad of gum ")]), _vm._v(" "), _c('p', {
    staticClass: "C1104"
  }, [_vm._v("and rolled it out of this park and onto the front lawn ")]), _vm._v(" "), _c('p', {
    staticClass: "C1104"
  }, [_vm._v("of the richest motherfucker in this city?” ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('p', {
    staticClass: "C1104"
  }, [_vm._v("stamped. Perhaps the walls are ")]), _vm._v(" "), _c('p', {
    staticClass: "C1104"
  }, [_vm._v("closing in on us. “Hey, how many of you ")]), _vm._v(" "), _c('p', {
    staticClass: "C1104"
  }, [_vm._v("have been on this ride before?” ")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "C1104"
  }, [_vm._v("though somebody’s shouting "), _c('em', [_vm._v("stop it. ")]), _vm._v("Some young blacks ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "C1104"
  }, [_c('span', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("We ")]), _vm._v("have all paid our admission and had our hands ")])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ee1eb028","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/06_1_In_Lin.vue
// module id = 72
// module chunks = 0